import { render, staticRenderFns } from "./StatusIndex.vue?vue&type=template&id=56ac70e5&scoped=true"
import script from "./StatusIndex.vue?vue&type=script&lang=js"
export * from "./StatusIndex.vue?vue&type=script&lang=js"
import style0 from "./StatusIndex.vue?vue&type=style&index=0&id=56ac70e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ac70e5",
  null
  
)

export default component.exports